<template>
  <aside class="company-wall-details-cta-skeleton">
    <div class="company-wall-details-cta-skeleton--mobile">
      <PSkeleton height="48px" />
    </div>
    <div class="company-wall-details-cta-skeleton--desktop">
      <div class="company-wall-details-cta-skeleton__title">
        <PSkeleton height="22px" style="width: 90%" />
        <PSkeleton height="22px" style="width: 50%" />
      </div>
      <div class="company-wall-details-cta-skeleton__select">
        <PSkeleton width="115px" />
        <PSkeleton height="46px" />
      </div>
      <PSkeleton height="46px" />
    </div>
  </aside>
</template>

<script setup lang="ts">
import { PSkeleton } from "@solvari/components";
</script>

<style scoped lang="postcss">
.company-wall-details-cta-skeleton {
  @apply sticky bottom-3 z-30;

  &--desktop {
    @apply hidden;
  }

  &__title {
    @apply flex flex-col gap-1;
  }

  &__select {
    @apply flex flex-col gap-2;
  }

  @screen 900 {
    @apply sticky top-6 shrink-0 self-start rounded border p-6;

    &--desktop {
      @apply flex flex-col gap-5;
    }

    &--mobile {
      @apply hidden;
    }
  }
}
</style>
